module.exports = __webpack_public_path__ + "img/cards-test.c1ff9b42.png";